var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLegalRights = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Legal-Scale-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Legal Scale 1 Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 13.09a0.92 0.92 0 0 0 -0.09 -0.39l-2.74 -6.18a0.25 0.25 0 0 1 0.15 -0.34A1 1 0 0 0 21 4.23h-7.75A0.25 0.25 0 0 1 13 4V1.75a1 1 0 0 0 -2 0V4a0.25 0.25 0 0 1 -0.25 0.25H3a1 1 0 0 0 -0.32 1.95 0.21 0.21 0 0 1 0.15 0.14 0.23 0.23 0 0 1 0 0.2L0.09 12.7a0.92 0.92 0 0 0 -0.09 0.39 4.5 4.5 0 1 0 9 0 1.07 1.07 0 0 0 -0.1 -0.4L6.19 6.58a0.26 0.26 0 0 1 0 -0.24 0.26 0.26 0 0 1 0.21 -0.11h4.33a0.25 0.25 0 0 1 0.25 0.25V21a0.25 0.25 0 0 1 -0.25 0.25H9.08a1 1 0 1 0 0 2h5.81a1 1 0 0 0 0 -2h-1.64A0.25 0.25 0 0 1 13 21V6.48a0.25 0.25 0 0 1 0.25 -0.25h4.33a0.26 0.26 0 0 1 0.21 0.11 0.26 0.26 0 0 1 0 0.24L15.1 12.7a1.07 1.07 0 0 0 -0.1 0.4 4.5 4.5 0 1 0 9 0Zm-21.19 -0.74a0.26 0.26 0 0 1 -0.21 -0.11 0.29 0.29 0 0 1 0 -0.24l1.67 -3.79a0.25 0.25 0 0 1 0.46 0L6.41 12a0.29 0.29 0 0 1 0 0.24 0.26 0.26 0 0 1 -0.21 0.11Zm15 0a0.26 0.26 0 0 1 -0.21 -0.11 0.29 0.29 0 0 1 0 -0.24l1.68 -3.79a0.25 0.25 0 0 1 0.46 0L21.42 12a0.29 0.29 0 0 1 0 0.24 0.26 0.26 0 0 1 -0.21 0.11Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLegalRights);
export default ForwardRef;